import { render, staticRenderFns } from "./ContactsImport.vue?vue&type=template&id=1396ba58&scoped=true"
import script from "./ContactsImport.vue?vue&type=script&lang=js"
export * from "./ContactsImport.vue?vue&type=script&lang=js"
import style0 from "./ContactsImport.vue?vue&type=style&index=0&id=1396ba58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396ba58",
  null
  
)

export default component.exports